export function addArray(arr1: number[], arr2: number[]): number[] {
    var result = []
    for(var i = 0; i < arr1.length && i < arr2.length; i++) {
        result.push( arr1[i] + arr2[i])
    }
    return result;
}

export function substractArray(arr1: number[], arr2: number[]): number[] {
    var result = []
    for(var i = 0; i < arr1.length && i < arr2.length; i++) {
        result.push( arr1[i] - arr2[i])
    }
    return result;
}

export function multiplyArrayByScalar(arr: number[], scalar: number): number[] {
    var result = []
    for(var i = 0; i < arr.length; i++) {
        result.push( arr[i] * scalar)
    }
    return result;
}